<template>
    <main class="pt-3 pb-0">

        <v-snackbar
          v-model="alertBar"
          :timeout="alertMsgTimeout"
        >
            {{ alertMsg }}
        </v-snackbar>

        <v-dialog v-model="isLoading" width="200" persistent no-click-animation>
            <div class="modalContainer">

                <div class="loadingWrapper py-8 text-center">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <p class="mt-4 text-center">Loading...</p>
                </div>

            </div>
        </v-dialog>

        <div class="campaignContainer" v-if="!isSubmitted">
            <v-container fluid>
                <v-row justify="center">
                    <v-col cols="12">
                        <img :src="bannerImage" width="100%" />
                    </v-col>
                    <v-col cols="12">
                        <div v-html="campaignIntro">
                        </div>
                    </v-col>
                </v-row justify="center">
            </v-container>
        </div>
        <div class="campaignWrapper" :class="isSubmitted?'thankyouBg':''">
            <div class="campaignDataForm" :class="isSubmitted?'thankyouMsg':''">

                <div class="formWrapper">
                    <div class="py-6" v-if="isSubmitted">
                        <p class="formHeader">{{ campaignThankTitle }}</p>
                        <p class="formSubHeader" v-html="campaignThankBody"></p>
                    </div>

                    <div class="py-6" v-if="!isSubmitted">
                        <p class="formHeader">Register Here</p>
                        <!-- <p class="formSubHeader">Fill out the form for more information on the best-suited solution for your team.</p> -->
                    </div>

                    <div class="campaignContainer"  v-if="!isSubmitted">
                        <v-container fluid>
                            <v-row justify="center">

                                <v-col cols="12">
                                    <v-form ref="campaignDataForm" v-model="campaignDataFormValid" >
                                        <v-container fluid>
                                            <v-row>

                                                <v-col cols="12" sm="6" >
                                                    <v-text-field
                                                        v-model="campaignData.firstName"
                                                        label="First Name"
                                                        :rules="firstNameFieldRules"
                                                        class="required"
                                                        outlined
                                                        dark
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" >
                                                    <v-text-field
                                                        v-model="campaignData.lastName"
                                                        label="Last Name"
                                                        :rules="lastNameFieldRules"
                                                        class="required"
                                                        outlined
                                                        dark
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="campaignData.jobTitle"
                                                        label="Job Title"
                                                        :rules="jobTitleFieldRules"
                                                        class="required"
                                                        outlined
                                                        dark
                                                    ></v-text-field>
                                                </v-col>



                                                <v-col cols="12" sm="6" >
                                                    <v-text-field
                                                        v-model="campaignData.organisationName"
                                                        label="Company"
                                                        :rules="companyNameFieldRules"
                                                        class="required"
                                                        outlined
                                                        dark
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="campaignData.email"
                                                        label="Work Email"
                                                        :rules="emailFieldRules"
                                                        class="required"
                                                        outlined
                                                        dark
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="campaignData.phoneNo"
                                                        label="Phone Number"
                                                        :rules="phoneNoFieldRules"
                                                        outlined
                                                        dark
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6">
                                                    <v-autocomplete
                                                        :items="industryOption"
                                                        label="Industry"
                                                        v-model="campaignData.industry"
                                                        outlined
                                                        class="required"
                                                        :rules="requiredFieldRules"
                                                        dark
                                                    ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" sm="6">
                                                    <v-select
                                                        :items="interestedInOption"
                                                        label="I am interested in"
                                                        v-model="campaignData.interestedIn"
                                                        outlined
                                                        :rules="requiredFieldRules"
                                                        dark
                                                        multiple
                                                    ></v-select>
                                                </v-col>

                                                <v-col cols="12">
                                                    <v-checkbox
                                                        v-model="campaignData.agreePromote"
                                                        label="Click to receive updates and information from SCMP Corporate Community"
                                                        dark
                                                    ></v-checkbox>
                                                </v-col>

                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" class="text-center">
                                                    <v-btn class="mx-2 btnSubmit" large @click="SubmitForm">Submit</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                </v-col>
                            </v-row>

                        </v-container>
                    </div>

                    <div class="disclamer">
                        <p>Your information is held in the strictest of confidence as indicated in our <a href="https://www.scmp.com/privacy-policy" target="_blank">privacy policy</a> and <a href="https://www.scmp.com/terms-conditions" target="_blank">online service agreement</a>. Our procedures have been designed to safeguard your personal data and ensure secure transactions.</p>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';

export default {
    name: 'Campaign',
    title () {
        return `SCMP Campaign`
    },
    data() {
        return {
            alertBar: false,
            alertMsg: "",
            alertMsgTimeout: -1,
            isSubmitted: false,
            isLoading: false,
            campaignTitle: "",
            bannerImage: "",
            campaignIntro:"",
            campaignThankTitle: "Thank you for registering for the 1-month-free SCMP Group Subscription Trial ",
            campaignThankBody: "<p>Thank you for registering for your SCMP Group Subscription free-trial.</p><p>A representative from SCMP will be reaching out shortly to activate your free-trial account(s).</p><p>You may also contact us at <a href='mailto:groupsubs@scmp.com'>groupsubs@scmp.com</a> with any questions.</p>",
            industryOption:[],
            interestedInOption:[],
            hearUsOption: [],
            countryOption: [],
            companySizeOption:[],
            campaignDataFormValid: false,
            requiredFieldRules:[
                v => !!v || 'This Field is required',
                v => (v && !!v.toString().trim()) || 'This Field is required',
            ],
            firstNameFieldRules:[
                v => !!v || 'First Name is required',
                v => (v && !!v.toString().trim()) || 'First Name is required',
                v => (v && !/[!@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?]+/.test(v)) || 'Name has special characters',
                v => (v && v.length <= 40) || 'Please input less than 40 character',
            ],
            lastNameFieldRules:[
                v => !!v || 'Last Name is required',
                v => (v && !!v.toString().trim()) || 'Last Name is required',
                v => (v && !/[!@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?]+/.test(v)) || 'Name has special characters',
                v => (v && v.length <= 50) || 'Please input less than 50 character',
            ],
            companyNameFieldRules:[
                v => !!v || 'Company name is required',
                v => (v && !!v.toString().trim()) || 'Company name is required',
                v => (v && v.length <= 250) || 'Please input less than 250 character',
            ],
            jobTitleFieldRules:[
                v => !!v || 'Job title is required',
                v => (v && !!v.toString().trim()) || 'Job title is required',
                v => (v && v.length <= 128) || 'Please input less than 128 character',
            ],
            phoneNoFieldRules:[
                v => (v.length === 0 || /^[0-9\s-+()*#]+$/.test(v)) || 'Phone no only allow number and symbol',
                v => (v.length <= 40) || 'Please input less than 40 character',
            ],
            emailFieldRules: [
                v => !!v || 'E-mail is required',
                v => (v && !!v.toString().trim()) || 'E-mail is required',
                v => (v && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)) || 'E-mail must be valid',
                v => (v && v.length <= 80) || 'Please input less than 80 character',
            ],

            campaignData:{
                campaignID: 0,
                firstName: "",
                lastName: "",
                organisationName: "",
                email:"",
                jobTitle:"",
                industry:"",
                companySize:"",
                interestedIn:"",
                hearUs:"",
                phoneNo:"",
                agreePromote: 1,
                country: "",
                utm_source: "",
                utm_medium: "",
                utm_content: "",
                utm_campaign_prefix: "",
                utm_campaign_type: "",
                utm_campaign_country: "",
                utm_campaign_product: "",
                utm_campaign_platform: "",
                utm_campaign_objective: "",
                utm_campaign_name: ""
            }
        };
    },
    computed: {

    },
    created(){
    },
    mounted(){
        this.InitApp();
    },
    watch:{


    },
    methods: {
        InitApp(){
            let vm = this,
                campaign_id = vm.$route.params.campaign_id,
                otherIndustryOption = {};

            vm.isLoading = true;
            axios.all([
                axios.post( process.env.VUE_APP_API_PATH +"/campaign/"+ campaign_id),
                axios.post( process.env.VUE_APP_API_PATH +"/industry"),
                axios.post( process.env.VUE_APP_API_PATH +"/hear_us"),
                axios.post( process.env.VUE_APP_API_PATH +"/company_size"),
                axios.post( process.env.VUE_APP_API_PATH +"/interested_in"),
                axios.post( process.env.VUE_APP_API_PATH +"/country")
            ]).then(axios.spread((...responses) => {
                const campaignRes = responses[0].data.output[0];
                const industryRes = responses[1].data;
                const hearusRes = responses[2].data;
                const sizeRes = responses[3].data;
                const interstedInRes = responses[4].data;
                const countryRes = responses[5].data;

                //vm.campaignTitle = campaignRes.campaign_name

                vm.bannerImage = process.env.VUE_APP_UPLOAD_PATH + '/' + campaignRes.campaign_banner_filename
                vm.campaignData.campaignID = campaignRes.campaign_id
                vm.campaignIntro = campaignRes.campaign_intro
                vm.campaignThankTitle = campaignRes.campaign_thank_title
                vm.campaignThankBody = campaignRes.campaign_thank_body
                //vm.industryOption = industryRes.output

                industryRes.output.forEach(element => {
                    if( element.text == "Others" ){
                        otherIndustryOption = element
                    }else{
                        vm.industryOption.push( element )
                    }
                });
                vm.industryOption.push( otherIndustryOption )
                vm.hearUsOption = hearusRes.output
                vm.companySizeOption = sizeRes.output
                vm.interestedInOption = interstedInRes.output
                vm.countryOption = countryRes.output

                vm.setTitle
                vm.isLoading = false;

                // use/access the results
            })).catch(errors => {
                console.log(error)
            })

            const
                queryString = window.location.search,
                urlParams = new URLSearchParams(queryString),
                utm_source = urlParams.get('utm_source'),
                utm_medium = urlParams.get('utm_medium'),
                utm_content = urlParams.get('utm_content'),
                utm_campaign = urlParams.get('utm_campaign');

            if(utm_source !== null && utm_source !== '') {
               vm.campaignData.utm_source = utm_source;
            }
            if(utm_medium !== null && utm_medium !== '') {
               vm.campaignData.utm_medium = utm_medium;
            }
            if(utm_content !== null && utm_content !== '') {
               vm.campaignData.utm_content = utm_content;
            }
            if(utm_campaign !== null && utm_campaign !== '') {
                let utmCampaignPrama = utm_campaign.split('-')

                if( utmCampaignPrama[0] != undefined && utmCampaignPrama[1] != undefined){
                    vm.campaignData.utm_campaign_prefix = utmCampaignPrama[0] + utmCampaignPrama[1]
                }

                if( utmCampaignPrama[2] != undefined ){
                    vm.campaignData.utm_campaign_type = utmCampaignPrama[2]
                }

                if( utmCampaignPrama[3] != undefined ){
                    vm.campaignData.utm_campaign_country = utmCampaignPrama[3]
                }

                if( utmCampaignPrama[4] != undefined ){
                    vm.campaignData.utm_campaign_product = utmCampaignPrama[4]
                }

                if( utmCampaignPrama[5] != undefined ){
                    vm.campaignData.utm_campaign_platform = utmCampaignPrama[5]
                }

                if( utmCampaignPrama[6] != undefined ){
                    vm.campaignData.utm_campaign_objective = utmCampaignPrama[6]
                }

                if( utmCampaignPrama.length > 8 ){
                    let namePrama = ""
                    for (let i = 7; i < utmCampaignPrama.length; i++) {
                      namePrama += utmCampaignPrama[i] + (i < utmCampaignPrama.length - 1 ? "-" : "");
                    }
                    vm.campaignData.utm_campaign_name = namePrama
                }else{
                    if( utmCampaignPrama[7] != undefined ){
                        vm.campaignData.utm_campaign_name = utmCampaignPrama[7]
                    }
                }                
            }
        },
        async SubmitForm(){

            let vm = this,
                data = new FormData();

            if( vm.$refs.campaignDataForm.validate() ){

                vm.isLoading = true;

                axios
                .post(process.env.VUE_APP_API_PATH +"/lead/save",  vm.campaignData)
                .then(response => {
                    vm.isLoading = false;
                    if( response.data == "Token Authorization Failed" ){
                        vm.AlertSnack("Authorization Failed.")
                    }else if( response.data == "failed" ){
                        vm.AlertSnack("Something is getting wrong. Please try again later")
                    }else{
                        sessionStorage.setItem('thankYouSource_' + vm.campaignData.campaignID, 'submit')
                        let thankYouPath = process.env.VUE_APP_BASE_PATH + 'campaign/' + vm.$route.params.campaign_slug + '/' + vm.$route.params.campaign_id + '/thank-you'
                        window.location.href = thankYouPath
                    }
                })
                .catch(error => {
                    console.log(error)
                })

            }

        },
        AlertSnack(text, timeout=2000){
            this.alertMsgTimeout = timeout;
            this.alertMsg = text;
            this.alertBar = true
        },
    }
}
</script>
